/*
 * Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
 * This software is the proprietary information of Irian Software Development SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SelectItem } from 'primeng/api';

@Injectable({ providedIn: 'root' })
export class BooleanSelectItemsProviderService {
  private readonly defaultTrueLabel = 'True';
  private readonly defaultFalseLabel = 'False';
  private readonly defaultNullLabel = 'All';

  constructor(private readonly translateService: TranslateService) {}

  getTranslatedBooleanSelectItems(trueLabel: string, falseLabel: string, nullLabel?: string) {
    const selectItems = [];

    if (this.translateService) {
      this.translateService.stream(falseLabel).subscribe((translation) => {
        selectItems.unshift({ value: false, label: translation });
      });
    } else {
      selectItems.unshift({ value: false, label: this.defaultFalseLabel });
    }

    if (this.translateService) {
      this.translateService.stream(trueLabel).subscribe((translation) => {
        selectItems.unshift({ value: true, label: translation });
      });
    } else {
      selectItems.unshift({ value: true, label: this.defaultTrueLabel });
    }

    if (nullLabel) {
      if (this.translateService) {
        this.translateService.stream(nullLabel).subscribe((translation) => {
          selectItems.unshift({ value: null, label: translation });
        });
      } else {
        selectItems.unshift({ value: null, label: this.defaultNullLabel });
      }
    }

    return selectItems;
  }

  getDefaultBooleanSelectItems(): Array<SelectItem> {
    const selectItems = [];
    selectItems.unshift({ value: false, label: this.defaultFalseLabel });
    selectItems.unshift({ value: true, label: this.defaultTrueLabel });
    selectItems.unshift({ value: null, label: this.defaultNullLabel });
    return selectItems;
  }
}
